export interface ApiError {
  response?: {
    data?: {
      message?: string;
      code?: string;
    };
  };
}

export function getErrorMessage(err: unknown, fallback = '操作失败'): string {
  const apiErr = err as ApiError;
  const msg = apiErr.response?.data?.message;
  if (typeof msg === 'string') return msg;
  // 后端 AllExceptionsFilter 会把 { code, message } 嵌套在 message 字段里
  if (typeof msg === 'object' && msg !== null && 'message' in msg) {
    const nested = (msg as Record<string, unknown>).message;
    if (typeof nested === 'string') return nested;
  }
  return fallback;
}
